module.exports = __webpack_public_path__ + "img/competition-cimb-2-2018.a85c5dca.png";